import type { LineItemsTableContent } from '@/blocks/domain/types/BlockContent/LineItemsTableContent';
import type { BlockContentDto } from '@/blocks/application/mappers/blockMapper';
import { mapLineItemsColumns } from '@/blocks/application/mappers/blockColumnsMapper';

export function mapLineItemsTableContent(dto: Extract<BlockContentDto, { kind: 'line_items_table' }>): LineItemsTableContent {
  return {
    kind: 'line_items_table',
    title: dto.title,
    columns: mapLineItemsColumns(dto),
    showRateScheduleNote: dto.show_rate_schedule_note
  };
}

export function fromLineItemsTableContent(content: LineItemsTableContent): Extract<BlockContentDto, { kind: 'line_items_table' }> {
  return {
    kind: 'line_items_table',
    title: content.title,
    show_rate_schedule_note: content.showRateScheduleNote,
    columns: content.columns.map((col) => ({
      key: col.key,
      label: col.label,
      visible: col.visible,
      sortOrder: col.order
    }))
  };
}
